window.META_URL = 'https://maps.tourdata.at/';
let _ttgMaps = {
    f: {

        getSaison: function(date) {

            date = date || new Date();

            var year = date.getUTCFullYear(),
                timestamp = date.getTime(),
                day, x;

            // see if date is before the 1am on the last sunday in march
            x = new Date(year + '-03-31 01:00Z');
            day = x.getUTCDay();
            if (day !== 0) x = new Date(year + '-03-' + (31 - day) + ' 01:00Z');

            if (timestamp < x.getTime()) return false;

            // see if date is after the last sunday in october
            x = new Date(year + '-10-31 01:00Z');
            day = x.getUTCDay();
            if (day !== 0) x = new Date(year + '-10-' + (31 - day) + ' 01:00Z');

            if (timestamp >= x.getTime()) return false;

            // it's summer
            return true;
        },

        isEmpty: function(mixed_var) {
            var undef, key, i, len;
            var emptyValues = [undef, null, false, 0, "", "0", ''];

            for (i = 0, len = emptyValues.length; i < len; i++) {
                if (mixed_var === emptyValues[i]) {
                    return true;
                }
            }

            if (typeof mixed_var === "object") {
                for (key in mixed_var) {
                    return false;
                }
                return true;
            }

            return false;
        },

        truncateString: function(str, length) {
            str = he.decode(str);
            return str.length > length ? str.substring(0, length - 3) + '...' : str;
        }

    },
    mapOptions: {
        container: '',
        experience: '',
        fullscreenControl: true,
        fullscreenControlPosition: 'top-right',
        geolocateControl: true,
        geolocateControlPosition: 'top-left',
        navigationControl: true,
        // navigationControl: {
        //     options: {
        //         showCompass: false,
        //         showZoom: false,
        //         visualizePitch: true
        //     }
        // },
        style: 'Topo', // Straße||Hybrid||Luftbild
        styleControl: true,
        zoom: 7,
        maxZoom: 10,
        minZoom: 5,
        pitch: 45, // Tilt/Neigung der Karte (Function muss beim Initialisieren jeder Map manuell gemacht werden)
        limitBounds: 20,
        infoWindowType: 'inlineListMap' // default || inlineListMap
    },
    metaParams: {
        // template: 'ET2014A.json', // wird nicht berücksichtigt, keine Ahnung warum
        limit: 50,
        offset: 0
    },
    activePin: []
},
    ttgMaps = [],
    fullscreenDetailSite;

_ttgMaps.lang = $("html").attr("lang");
_ttgMaps.pinColors = {
    default: '#3c3c3c',
    // selected: '#95c11f'
    selected: '#28b8ce',
    startOfTour: '#95c11f',
    endOfTour: '#c20735',
    wegpunkte: '#28b8ce'
};
_ttgMaps.types = {
    Hotel: 'Vermieter',
    Gastro: 'Gastro',
    POI: 'Poi',
    Tour: 'Tour',
    Package: 'GlobalePauschale',
    Event: 'Veranstaltung',
    City: 'OrteInformation',
    Area: 'Gebiet'
};
_ttgMaps.saison = (_ttgMaps.f.getSaison()) ? "sommer" : "winter";

_ttgMaps.f = {

    setCloseButton: function(item) {

        let $x = $('<span />');
        $x.addClass("fa-solid fa-xmark maps-close-btn").prop({
            'aria-hidden': 'true'
        });
        return $x;

    },

    setSection: function(item) {
        return $('<div class="ttgMapsPopupContentSection" data-type="' + item.type + '" data-sourceId="' + item.id + '" data-guid="' + item.global_id + '" />');
    },

    setTitle: function(item) {
        if (item.title) {
            return $('<div class="ttgMapsPopupTitle">' + item.title + '</div>');
        }
    },

    setCity: function(item) {
        if (item.city) {
            return $('<div class="ttgMapsPopupCity">' + item.city + '</div><div class="ttgMapsPopupTrenner" />');
        }
    },

    setImage: function(item) {
        let objectType = _ttgMaps.types[item.type].toLowerCase();
        let img = $('<img />').attr('src', 'https://media.tourdata.at/exp/' + _ttgMaps.saison + '/ltoZimmerBild/' + objectType + '/' + item.id + '.png');
        return $('<div class="ttgMapsPopupImg" />').append(img);
    },

    setDescription: function(item) {
        let text = _ttgMaps.f.getPinText(item.texts, 250);
        if (text) {
            return $('<div class="ttgMapsDescription">' + text + '</div>');
        }
    },

    setFooter: function(item) {

        let $footerWrapper = $('<div class="ttgMapsPopupFooter" />');
        $footerWrapper.append('<div class="ttgMapsPopupTrenner" />');
        let $footerLeft = $('<div class="ttgMapsPopupFooterLeft ttgMapsPopupFooterLeft_' + item.id + '" />');

        let $oHours_termin_rZeitraum = $('<div />').addClass("openingHours termin reisezeitraum").data({
            id: item.id
        });
        $oHours_termin_rZeitraum.appendTo($footerLeft);

        let $auslastung = $('<div />').addClass("auslastung mt-2").data({
            id: item.id
        });
        $auslastung.appendTo($footerLeft);

        $footerWrapper.append($footerLeft);
        $footerWrapper.append('<div class="ttgMapsPopupFooterRight"><a href="' + item.web + '" target="_blank">mehr dazu</a></div');
        $footerWrapper.append('<div class="ttgMapsClearBoth" />');

        return $footerWrapper;

    },

    getObjectReisezeitraum: function(item) {

        let $obj = $('.ttgMapsPopupFooterLeft_' + item.id + ' .reisezeitraum');

        if (item.type == 'Package') {
            let reisezeitraum = '';
            item.attributes.filter(function(e) {
                // nur wenn bei dem Objekt auf die Auslastung vorhanden ist, soll diese nochmal asynchron geladen werden
                if (e.key == "NextFixtureStart") {
                    let nextFixtureStart = new Date(e.value);
                    reisezeitraum += $('#td').data('label-reisezeitraum') + ': ' + moment(nextFixtureStart).format('DD.MM.YYYY');
                }
                if (e.key == 'NextFixtureEnd') {
                    let nextFixtureEnd = new Date(e.value);
                    reisezeitraum += ' - ' + moment(nextFixtureEnd).format('DD.MM.YYYY');
                }
            });

            item.numbers.filter(function(e) {
                if (e.type == "PREIS_AB") {
                    reisezeitraum += '<br />' + $('#td').data('label-ab') + ' &euro; ' + e.value;
                }
            });
            $obj.html(reisezeitraum);
        }
    },

    getObjectTermin: function(item) {

        let $obj = $('.ttgMapsPopupFooterLeft_' + item.id + ' .termin');

        if (item.type == 'Event') {
            item.attributes.filter(function(e) {
                // nur wenn bei dem Objekt auf die Auslastung vorhanden ist, soll diese nochmal asynchron geladen werden
                if (e.key == "NextFixtureStart") {
                    let nextFixtureStart = new Date(e.value);
                    $obj.html($('#td').data('label-termin') + ': ' + moment(nextFixtureStart).format('DD.MM.YYYY, HH:mm'));
                }
            });
        }
    },

    getObjectOpeningHours: function(item) {

        let itemObj = {};
        itemObj.ObjectID = item.id;
        itemObj.ObjectType = item.type;

        let params = {};

        if (item.type == 'Gastro' || item.type == 'POI') {

            params.ObjectType = item.type;
            params.ObjectID = item.id;
            params.MetaExperience = $('#td').data('metaconfig');

            let $obj = $('.ttgMapsPopupFooterLeft_' + item.id + ' .openingHours');
            // let $oHours = $('<div />').addClass("openingHours");

            $.ajax({
                type: "POST",
                url: '/index.php?id=' + rootPage + '&type=1890&L=' + $('#td').data('syslanguageuid'),
                data: "object=" + JSON.stringify(params) + '&style=tdLists',
                beforeSend: function() {
                    $obj.html('<span class="loader-openinghours fa-solid fa-circle-notch fa-spin"></span>');
                },
                success: function(result) {
                    $obj.remove('.loader-openinghours');
                },
                error: function() {
                    $obj.remove('.loader-openinghours');
                },
                complete: function(result) {
                    $obj.html(result.responseText);
                }
            });
        } else {
            return;
        }

    },

    getObjectAuslastung: function(item) {

        let $obj = $('.ttgMapsPopupFooterLeft_' + item.id + ' .auslastung');

        const hasAuslastung = item.attributes.filter(function(e) {
            // nur wenn bei dem Objekt auf die Auslastung vorhanden ist, soll diese nochmal asynchron geladen werden
            if (e.key == "PeopleCounterState") {
                $.ajax({
                    type: "POST",
                    url: '/index.php?id=' + rootPage + '&type=1950&L=' + $('#td').data('syslanguageuid'),
                    data: {
                        lang: _ttgMaps.lang,
                        sysLanguageUid: $('#td').data('syslanguageuid'),
                        L: $('#td').data('syslanguageuid'),
                        auslastung: e.value,
                        sourceid: item.id,
                        tdType: item.type,
                    },
                    // beforeSend: function() {},
                    success: function(result) {
                        $obj.html(result);
                    },
                    // error: function() {},
                    complete: function() {}
                });
            }
        });

    },

    getPins: function(pins) {
        let tmp = pins.split("-");
        let objects = [];
        $.each(tmp, function(key, item) {
            if (item) {
                let t = item.split(":");
                objects.push("(type:" + t[0] + " id:" + t[1] + ")");
            }
        });

        return objects.join(' OR ');
    },

    getPinText: function(data, chars) {

        let text = '';
        for (const item of data) {
            if (item.rel == 'teaser' && item.type == "text/plain") {
                text = item.value;
            }
        }

        let returnText = '';

        // Text ist leer
        if (_ttgMaps.f.isEmpty(text)) {
            // wenn ShortText nicht leer ist
            if (!_ttgMaps.f.isEmpty(data.ShortText)) {
                returnText = _ttgMaps.f.truncateString(data.ShortText, chars);
            }
        } else {
            returnText = _ttgMaps.f.truncateString(text, chars);
            // wenn in data.Text trotzdem nichts drinnen ist aber data.Text.length == 1 ist, dann soll ShortText noch angehängt werden
            if ((text).length == 1 && !_ttgMaps.f.isEmpty(data.ShortText)) {
                returnText += _ttgMaps.f.truncateString(data.ShortText, chars);
            }
        }

        return returnText;

    },

    initMap: function() {

        /* ERZEUGE MAP, SOFERN NOCH NICHT VORHANDEN */
        if (ttgMaps[0] === undefined) {
            if (Done.Maps.isSupported()) {

                ttgMaps[0] = Done.Maps.newMap(_ttgMaps.mapOptions);
                ttgMaps[0].on('load', _ttgMaps.f.loadListMap);
                ttgMaps[0].on('item-selected', (ev) => {
                    _ttgMaps.f.selectMapItem(ev.item.item);
                });
            }
        } else {
            return;
        }

    },

    getLicenseKey: async function() {
        // falls noch kein Key: einmalig vom Server holen
        if (!_ttgMaps.metaParams.licensekey) {
            try {
                const url = window.location.protocol + "//" + window.location.host + "/?type=2110";
                const resp = await $.getJSON(url, { experience: _ttgMaps.metaParams.experience });
                _ttgMaps.metaParams.licensekey = resp.randomToken;
            } catch (err) {
                console.error('Kein META License-Key verfügbar:', err);
                // ggf. Fallback oder Anzeige einer Fehlermeldung
            }
        }
    },

    loadListMap: async function() {

        // falls noch kein Key: einmalig vom Server holen
        await _ttgMaps.f.getLicenseKey();

        ttgMaps[0].map.setPitch(_ttgMaps.mapOptions.pitch);
        // ttgMaps[0].setMapStyle('Topo');

        const mapLayer = await ttgMaps[0].showContent(_ttgMaps.metaParams);

        ttgMaps[0].unselectAll();
        ttgMaps[0].fitLayer(mapLayer);
        // ttgMap.resize();

        _ttgMaps.mapOptions.mapResized = true;

        // /* MOVE EVENTS */
        // ttgMap.getMap().on("moveend", (ev) => {
        //     if (_ttgMaps.mapOptions.mapResized === true) {
        //         if (ev.originalEvent) {
        //             _ttgMaps.f.mapSearchInBounds(_ttgMaps.mapOptions.layer++); // apply map bounds -> filter bbox
        //         }
        //     }
        // });

        _ttgMaps.f.loading($(ttgMaps[0].map._container), 'remove');

    },

    getMapItem: function(item) {

        try {
            return $.ajax({
                type: "POST",
                url: window.location.protocol + "//" + window.location.host + "/?type=2090",
                data: {
                    experience: _ttgMaps.metaParams.experience,
                    mkt: _ttgMaps.metaParams.mkt,
                    type: item.type,
                    limit: 1,
                    q: 'id:' + item.id,
                    template: 'ET2014A.json'
                },
                dataType: "jsonp"
            });
        } catch (e) {
            console.error(e);
        }

    },

    selectMapItem: function(selectItem, $listClick, mapObj, ttgTrail) {

        if ($listClick) {
            selectItem.type = $td.data('type');
        }

        _ttgMaps.f.getMapItem(selectItem).then(
            response => {

                let mapItem = response.items[0];
                let flyTo = {
                    center: [mapItem.geo.main.longitude, mapItem.geo.main.latitude]
                };

                /* ZEIGE PIN, INFOWINDOW & SPRINGE ZU COORDS inkl. ZOOM */
                if ($listClick) {

                    flyTo.zoom = 12; // bei listClick zoome rein

                    // ttgMap.showItem(mapItem); // zeige Pin
                    // ttgMap.selectItem(mapItem);

                    /* SET VISIBLEINMAP CLASS 2 LIST ENTRY */
                    _ttgMaps.f.listMap.visibleInMapListIndicator($listClick);

                } else {

                    /* SET VISIBLEINMAP CLASS 2 LIST ENTRY */
                    if (!ttgTrail) {
                        _ttgMaps.f.listMap.visibleInMapListIndicator($td.find('#resultSet .entries .entry.tdid-' + selectItem.id));
                    }

                }

                _ttgMaps.f.setActivePin(flyTo, mapObj, ttgTrail);

                const popup = _ttgMaps.f.drawPinAndContent(mapItem, mapObj, ttgTrail);

                // if (_ttgMaps.mapOptions.infoWindowType === 'default') {
                //     ttgMap.showPopup(popup);
                //     /* ASYNCHRON ITEM DATA */
                //     _ttgMaps.f.getObjectOpeningHours(mapItem);
                //     _ttgMaps.f.getObjectTermin(mapItem);
                //     _ttgMaps.f.getObjectReisezeitraum(mapItem);
                //     _ttgMaps.f.getObjectAuslastung(mapItem);
                // } else {

                if (mapObj) {

                    $(mapObj.map._container).find('.selectedMapItemInfo').remove();
                    popup.fullscreen.prependTo($(mapObj.map._container).find('.ttgFullScreenSelectedNCEMapItem').addClass('selected'));

                } else {

                    $('.selectedMapItemInfo').remove();
                    popup.inline.prependTo($('#ttgInlineListSelectedMapItem').addClass('selected'));
                    popup.fullscreen.prependTo($('#ttgFullScreenSelectedMapItem').addClass('selected'));

                }

                // }
            }
        );

    },

    setActivePin: function(flyTo, mapObj, ttgTrail) {

        $mapObj = (mapObj) ? mapObj : ttgMaps[0]; // falls MapObj übergeben nutze das ansonsten nimm ttgMap
        // console.log($($mapObj.map._container).prop('id'));

        $mapObj.clearTour();
        if (_ttgMaps.activePin[$($mapObj.map._container).prop('id')]) {
            _ttgMaps.activePin[$($mapObj.map._container).prop('id')].remove();
        }
        _ttgMaps.activePin[$($mapObj.map._container).prop('id')] = $mapObj.addMarker({
            lng: flyTo.center[0],
            lat: flyTo.center[1],
            color: _ttgMaps.pinColors.selected
        });

        if ($(_ttgMaps.activePin[$($mapObj.map._container).prop('id')]._element).find('span').length === 0) {
            $(_ttgMaps.activePin[$($mapObj.map._container).prop('id')]._element)
                .addClass('ttgMaps_activePin')
                .append(
                    $('<span />').addClass('ttgMaps_pinSymbol').html('<i class="fa-fw ' + _ttgMaps.mapOptions.markerTypes.flag + '"></i>')
                );
        }

        if (!ttgTrail) {
            $mapObj.flyTo(flyTo);
            $mapObj.resize();
        }

    },

    drawPinAndContent: function(item, mapObj, ttgTrail) {

        if (item.type === 'Tour') {
            _ttgMaps.f.showTourAndElevationChart(item, mapObj, ttgTrail);
        } else {
            $('.nce-chart').removeClass('tourIsSelected').empty();
        }

        switch (_ttgMaps.mapOptions.infoWindowType) {

            case 'default':
                let popup = ttgMaps[0].createPopup(item);
                let $wrapper = $('<div />');
                let $content = $('<div class="ttgMapsPopupContent" />');

                /* TITLE & CITY */
                let $header = $('<div class="ttgMapsPopupHeader" />');
                $header.append(_ttgMaps.f.setCloseButton(item));
                $header.append(_ttgMaps.f.setTitle(item));
                $header.append(_ttgMaps.f.setCity(item));
                $header.appendTo($content);

                /* BILD & BESCHREIBUNG */
                let $section = _ttgMaps.f.setSection(item);
                $section.append(_ttgMaps.f.setImage(item));
                $section.append(_ttgMaps.f.setDescription(item));
                $section.appendTo($content);

                /* FOOTER */
                let $footer = _ttgMaps.f.setFooter(item);
                $footer.appendTo($content);

                /* CUSTOM CONTENT & CO */
                switch (item.type) {

                    case 'Hotel':
                        break;

                    case 'Gastro':
                        break;

                    case 'POI':
                        break;

                    case 'Tour':
                        // _ttgMaps.f.showTourAndElevationChart(item);
                        break;

                    case 'Package':
                        break;

                    case 'City':
                        break;

                    case 'Event':
                        break;

                }

                $content.appendTo($wrapper);

                popup.getHTML = () => $wrapper.html();
                return popup;

            case 'inlineListMap':

                let $entryInfo = $('<div />').addClass('selectedMapItemInfo'),
                    $title = $('<div />').addClass('entryTitle'),
                    loc = document.location.href,
                    locPos = loc.search('.html'),
                    locStart = loc.slice(0, locPos),
                    oesPos = item.web.search('/oesterreich-'),
                    detailUrl = locStart + item.web.slice(oesPos),
                    $detailLink = $('<a />').prop({ href: detailUrl, class: 'mapDetaillink' });

                if (ttgTrail) {
                    $detailLink.html($('#chart').data('zurdetailseitewechseln') + '<span class="fa-solid fa-arrow-right" aria-hidden="true"></span>');
                } else {
                    $detailLink.html($('#td #listOptions').data('zurdetailseitewechseln') + '<span class="fa-solid fa-arrow-right" aria-hidden="true"></span>');
                }

                /*
                // OOEAT-5313 : Don't Link Title
                $detailLink = $('<a />').prop({
                    'href': detailUrl
                }).html(item.title + '<span class="fa-solid fa-arrow-right" aria-hidden="true"></span>');
                $title.append($detailLink);
                */
                $title.html(item.title);

                if (!ttgTrail) {

                    // $detailLink = $('<a />').prop({
                    //     'href': $td.find('#resultSet .entries .entry.tdid-' + item.id + ' h2 a').prop('href'),
                    //     'title': $('#td #listOptions').data('zurdetailseitewechseln')
                    // }).html('<i class="fa-solid fa-arrow-right"></i>');
                    // $title.append($detailLink);

                    /* 
                    // OOEAT-5313 : entferne Jump2ListEntryLink
                    let $jump2ListEntryLink = $('<a />').prop('href', '#'),
                        $fa = $('<span class="fas fa-list" aria-hidden="true"></span>'),
                        $t = $('<span class="text">' + $('#td #listOptions').data('zumlistenelementspringen') + '</span>');
                    $jump2ListEntryLink.addClass('jumpToListLink').append($fa, $t).click(function(e) {
                        e.preventDefault();
                        $td.find('#resultSet .entries .entry.tdid-' + item.id).animatescroll({
                            padding: 150
                        });
                    }).appendTo($entryInfo);
                    */

                } else {

                    // let loc = document.location.href,
                    //     locPos = loc.search('.html'),
                    //     locStart = loc.slice(0, locPos),
                    //     oesPos = item.web.search('/oesterreich-'),
                    //     detailUrl = locStart + item.web.slice(oesPos);

                    // $detailLink = $('<a />').prop({
                    //     'href': detailUrl
                    // }).html('<i class="fa-solid fa-arrow-right"></i>');
                    // $title.append($detailLink);

                }

                $title.appendTo($entryInfo);
                $detailLink.appendTo($entryInfo);

                return {
                    inline: $entryInfo,
                    fullscreen: $entryInfo.clone()
                };

        }

    },

    showTourAndElevationChart: async function(item, mapObj, ttgTrail) {

        const routeDetails = function() {
            if (item.length && item.duration) {
                let laenge = (item.length / 1000).toFixed(1).toString().replace('.', ','),
                    dauer = (item.duration / 60 / 60).toFixed(2).toString().replace('.', ',');

                let dauerArr = dauer.split(',');
                dauerArr[1] = 60 / 100 * parseInt(dauerArr[1]);
                dauerArr[1] = Math.floor(dauerArr[1]);

                return 'Länge: ' + laenge + ' km | Dauer: ' + dauerArr[0] + 'h ' + dauerArr[1] + 'm';
            } else {
                return false;
            }
        };

        $mapObj = (mapObj) ? mapObj : ttgMaps[0]; // falls MapObj übergeben nutze das ansonsten nimm ttgMap

        var mode = 'list';
        if ($($mapObj.map._container).hasClass('nce-karte')) {
            mode = 'nce';
        } else if ($($mapObj.map._container).hasClass('ttg-detail-map')) {
            mode = 'detail';
            $('#chartFullscreen, #chartDetail_mobile, #chartDetail_desktop').empty();
        }

        const fixed = {
            actualZoom: $mapObj.map.getZoom(),
            actualCenter: $mapObj.map.getCenter()
        };
        // console.log("fixedActualZoom: ", fixed);

        const tourLine = await $mapObj.showTour(item.global_id);

        if (ttgTrail) {
            // $mapObj.map.setZoom(fixed.actualZoom);
            // $mapObj.map.setCenter(fixed.actualCenter);
        }

        const points = tourLine.points.map((p) => new CompatLatLon(p.lat, p.lng));
        if (mode === 'detail') {

            // hoehenprofil_desktop
            const $chartDetailDesktop = $('#chartDetail_desktop');
            window.echartDetailDesktop = new eContentElevationChart($mapObj, {
                element: $chartDetailDesktop.prop('id'),
                hinweistext: $chartDetailDesktop.data('hinweistext'),
                routeDetails: routeDetails()
            });
            window.echartDetailDesktop.setPoints(points);

            // hoehenprofil_mobile
            const $chartDetailMobile = $('#chartDetail_mobile');
            window.echartDetailMobile = new eContentElevationChart($mapObj, {
                element: $chartDetailMobile.prop('id'),
                hinweistext: $chartDetailDesktop.data('hinweistext'),
                routeDetails: routeDetails()
            });
            window.echartDetailMobile.setPoints(points);

            // FULLSCREEN
            if ($mapObj.isFullscreen()) {
                setTimeout(function() {
                    const $chartDetailFullscreen = $('#chartFullscreen');
                    window.echartDetailFullscreen = new eContentElevationChart($mapObj, {
                        element: $chartDetailFullscreen.prop('id'),
                        fullScreenChart: true,
                        hinweistext: $chartDetailFullscreen.data('hinweistext'),
                        routeDetails: routeDetails()
                    });
                    window.echartDetailFullscreen.setPoints(points);
                }, 500);
            }

        } else if (mode === 'nce') {

            $($mapObj.map._container).find('.nce-chart').empty();

            const $chart = $('#chartFullScreen_' + $($mapObj.map._container).data('id'));
            $chart.addClass('tourIsSelected').empty();
            window.echartNCE['chart_' + $($mapObj.map._container).data('id')] = new eContentElevationChart($mapObj, {
                element: 'chartFullScreen_' + $($mapObj.map._container).data('id'),
                fullScreenChart: true,
                hinweistext: $($mapObj.map._container).data('chart_hinweistext'),
                routeDetails: routeDetails()
            });
            window.echartNCE['chart_' + $($mapObj.map._container).data('id')].setPoints(points);

        } else {

            $('#' + _ttgMaps.mapOptions.container).addClass('tourIsSelected');

            // INLINE
            const $chart = $('#chart');
            $chart.addClass('tourIsSelected').empty();
            window.echart = new eContentElevationChart($mapObj, {
                element: $chart.prop('id'),
                hinweistext: $('#td').data('chart_hinweistext'),
                routeDetails: routeDetails()
            });
            window.echart.setPoints(points);

            // FULLSCREEN
            const $chartFullscreen = $('#chartFullscreen');
            $chartFullscreen.addClass('tourIsSelected').empty();
            window.echartFullscreen = new eContentElevationChart($mapObj, {
                element: $chartFullscreen.prop('id'),
                fullScreenChart: true,
                hinweistext: $('#td').data('chart_hinweistext'),
                routeDetails: routeDetails()
            });
            window.echartFullscreen.setPoints(points);

        }

    },

    tourGeoString2Arr: function(geostring) {

        var tourStringArr = geostring.split(" "),
            tourStringArr2 = [],
            tourStringArr2i = 0;

        $.each(tourStringArr, function(k, v) {
            if (k % 2 == 0) {
                tourStringArr2[tourStringArr2i] = [];
                tourStringArr2[tourStringArr2i][1] = Number(v);
            } else {
                tourStringArr2[tourStringArr2i][0] = Number(v);
                tourStringArr2i++;
            }
        });
        tourStringArr2.pop();
        return tourStringArr2;

    },

    loading: function($map, remove) {

        if (!remove) {

            const $loading = $('<div />').addClass('ttgMaps_loading').html('<div class="pin"></div><div class="pulse"></div>');
            $map.css({
                'opacity': 0.25
            }).append($loading);

        } else {

            $map.css({
                'opacity': 1,
                'transition': 'opacity 1s ease-in-out'
            }).find('.ttgMaps_loading').remove();

        }

    },

    deactiveOutgoingLinks: function() {
        // beim Terminal müssen die Outgoing Links in der Karte deaktiviert werden
        if ($('body').hasClass('ttg-tdTerminal')) {
            $('#ttgDetailKarte, #ttgInlineListMap').find('a:not([href^="https://terminal.ttg.at"])').addClass('notClickable');
        }
    },

};

window.addEventListener('fullscreenchange', (event) => {

    if (document.fullscreen) {

        $('body').addClass('mapFullScreen').removeClass('mapInline');

        // Update Tour Höhenprofil FullSize (wegen Breite)
        $.each(ttgMaps, function() {
            var map = this;
            setTimeout(function() {
                if (map.currentTour !== undefined) {
                    _ttgMaps.f.showTourAndElevationChart({
                        global_id: map.currentTour.id
                    }, map);
                }
            }, 500);
        });

    } else {

        // RESET
        $('body').addClass('mapInline').removeClass('mapFullScreen');

        setTimeout(function() {
            $.each(ttgMaps, function() {
                this.resize();
                if (this.currentTour) {
                    this.fitBounds(this.currentTour.points);
                } else {
                    this.fitLayer(this.layers[0]);
                }
            });
        }, 1000);

    }

});